//LEADS (blops api) - URLs diretas das APIs
const API_LEADS_DOMAIN = `${process.env.REACT_APP_API_INT_LEADS}`
const API_LEADS_AUTH_DOMAIN = `${process.env.REACT_APP_API_INT_LEADS}`
export const GET_PUBLICACOES_PENDENTES = `${API_LEADS_DOMAIN}/api/publicacoes/pending`
export const UPDATE_PUBLICACAO = `${API_LEADS_DOMAIN}/api/publicacoes`
export const GET_PUBLICACAO = `${API_LEADS_DOMAIN}/api/publicacoes`
export const GET_SUGGEST_COMPANIES = `${API_LEADS_DOMAIN}/api/publicacoes/suggest/companies`
export const POST_PROCESSO = `${API_LEADS_DOMAIN}/api/processos`
export const GET_PROCESSO_COMPLETO = `${API_LEADS_DOMAIN}/api/processos`
export const UPDATE_PROCESSO = `${API_LEADS_DOMAIN}/api/processos`
export const GET_LEADS_ENVIADOS = `${API_LEADS_DOMAIN}/api/leads/sended`
export const CREATE_UPDATE_LEAD = `${API_LEADS_DOMAIN}/api/leads`
export const SEND_LEAD_CUSTOMER = `${API_LEADS_DOMAIN}/api/leads/send`
export const CREATE_UPDATE_APOLICE = `${API_LEADS_DOMAIN}/api/apolices`
export const POST_JWT_LOGIN = `${API_LEADS_AUTH_DOMAIN}/api/auth/login`
export const GET_MONITORED = `${API_LEADS_DOMAIN}/api/processos/monitored`
export const POST_RELETED = `${API_LEADS_DOMAIN}/api/processos/check-process-status`

//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"
export const POST_JWT_REGISTER = `${API_LEADS_AUTH_DOMAIN}/api/auth/register`

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_JWT_PASSWORD_FORGET = `${API_LEADS_AUTH_DOMAIN}/api/auth/recover`
export const POST_JWT_PASSWORD_FORGE = `${API_LEADS_AUTH_DOMAIN}/api/auth/jwt-forget-pwd`
export const POST_JWT_PASSWORD_RESET = `${API_LEADS_AUTH_DOMAIN}/api/auth/reset-password`
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"
export const GET_ME = `${API_LEADS_AUTH_DOMAIN}/api/auth/me`
export const PUT_CHANGE_PASSWORD = `${API_LEADS_AUTH_DOMAIN}/api/auth/change-password`

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//Mails
export const GET_INBOX_MAILS = "/inboxmails"
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail"
export const DELETE_INBOX_MAIL = "/delete/inboxmail"

//starred mail
export const GET_STARRED_MAILS = "/starredmails"

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails"

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails"

//Send mail
export const GET_SENT_MAILS = "/sentmails"

//Trash mail
export const GET_TRASH_MAILS = "/trashmails"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

// JOBS
export const GET_JOB_LIST = "/jobs"
export const ADD_NEW_JOB_LIST = "/add/job"
export const UPDATE_JOB_LIST = "/update/job"
export const DELETE_JOB_LIST = "/delete/job"

//Apply Jobs
export const GET_APPLY_JOB = "/jobApply"
export const DELETE_APPLY_JOB = "add/applyjob"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS / USUÁRIOS
export const GET_USERS = `${API_LEADS_DOMAIN}/api/usuarios`
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = `${API_LEADS_DOMAIN}/api/usuarios`
export const UPDATE_USER = `${API_LEADS_DOMAIN}/api/usuarios`
export const DELETE_USER = `${API_LEADS_DOMAIN}/api/usuarios`
export const TOGGLE_USER_STATUS = `${API_LEADS_DOMAIN}/api/usuarios`

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data"
export const GET_YEARLY_DATA = "/yearly-data"
export const GET_MONTHLY_DATA = "/monthly-data"

export const TOP_SELLING_DATA = "/top-selling-data"

export const GET_EARNING_DATA = "/earning-charts-data"

export const GET_PRODUCT_COMMENTS = "/comments-product"

export const ON_LIKNE_COMMENT = "/comments-product-action"

export const ON_ADD_REPLY = "/comments-product-add-reply"

export const ON_ADD_COMMENT = "/comments-product-add-comment"

export const GET_SOLUCIONARE_MOVEMENTS = `${process.env.REACT_APP_API_SOLUCIONARE_MOVEMENTS}`
export const GET_SOLUCIONARE_PROGRESS_CNJ = `${process.env.REACT_APP_API_SOLUCIONARE_PROGRESS_CNJ}`
